export * from "./inventory-before-release.component";
